import { render, staticRenderFns } from "./MemberCenter.vue?vue&type=template&id=c56c8cd6&scoped=true"
import script from "./MemberCenter.vue?vue&type=script&lang=js"
export * from "./MemberCenter.vue?vue&type=script&lang=js"
import style0 from "./MemberCenter.vue?vue&type=style&index=0&id=c56c8cd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56c8cd6",
  null
  
)

export default component.exports